// ------------------------------------
// Imports
// ------------------------------------
import {
  FETCH_DIRECT_PLANS_ANDROID_START,
  FETCH_DIRECT_PLANS_ANDROID_END,
  SELECT_DIRECT_PLANS_ANDROID,
  DIRECT_PLANS_ANDROID_ERROR,
  CHECKOUT_DIRECT_PLANS_ANDROID_START,
  CHECKOUT_DIRECT_PLANS_ANDROID_END
} from 'redux/actions/directPlansAndroid';
// ------------------------------------
// Reducer Handlers
// ------------------------------------
const initialState = {
  isFetching: false,
  isError: false,
  info: {},
  selectedPlan: {},
  isProcessingCheckout: false
};

const REDUCER_HANDLERS = {
  [FETCH_DIRECT_PLANS_ANDROID_START]: state => ({
    ...state,
    isFetching: true,
    isError: false
  }),
  [FETCH_DIRECT_PLANS_ANDROID_END]: (state, action) => ({
    ...state,
    info: action.payload,
    isFetching: false
  }),
  [SELECT_DIRECT_PLANS_ANDROID]: (state, action) => ({
    ...state,
    selectedPlan: action.payload
  }),
  [DIRECT_PLANS_ANDROID_ERROR]: state => ({
    ...state,
    isError: true,
    isFetching: false
  }),
  [CHECKOUT_DIRECT_PLANS_ANDROID_START]: state => ({
    ...state,
    isProcessingCheckout: true
  }),
  [CHECKOUT_DIRECT_PLANS_ANDROID_END]: state => ({
    ...state,
    isProcessingCheckout: false
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function directPlansAndroid(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/directPlansAndroid.js